import { PureComponent } from "react";

export default class FlexibleCardsGridMobileComponent extends PureComponent {
  render() {
    return <div className="flexible-cards-grid-mobile-component" />;
  }
}
